import React, { Suspense, useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core'
import { AuthProvider } from './contexts/AuthProvider'
// import AuthInit from './modules/auth/redux/AuthInit'
import { Routes } from './routing/Routes'
import Swal from 'sweetalert2'


type Props = {
  basename: string
}

const App: React.FC<Props> = ({ basename }) => {



  // useEffect(() => {
  //   const anuncio = localStorage.getItem('fone-novo')
  //   const atual = new Date().getTime();
  //   const mostrar = !anuncio || Math.abs((Number(anuncio) - atual) / 1000 % 60) >= 28800


  //   if (mostrar) {
  //     Swal.fire({
  //       title: '<h2>Atualização número do suporte</h2>',
  //       width: '400px',
  //       html: '<div style="text-align: left;"><b>Olá</b>, <div style="margin-top: 12px;">Prezado cliente, </div>' +
  //         '<div>Para melhor atendê-lo, nosso número de suporte foi alterado. Por favor, atualize seus contatos para o novo número: <b>11 954560161</b>.</div> </br>',
  //       timer: 20000,
  //       icon: 'info',
  //       showConfirmButton: false
  //     });
  //     localStorage.setItem('fone-novo', new Date().getTime().toString());
  //   }
  // }, []);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <BrowserRouter basename={basename}>
        <I18nProvider>
          <LayoutProvider>
            <AuthProvider>
              <>
                <Routes />
              </>
            </AuthProvider>
          </LayoutProvider>
        </I18nProvider>
      </BrowserRouter>
    </Suspense>
  )
}

export { App }

